// all name is CamelCase
const authentication = {
  Login: 'user/login',
  LoginByCode: 'user/verify',
  verifyCode: 'user/add-verify-code',
}
export default authentication
